import { GetterTree } from "vuex";
import { NewslettersState } from "./types";
import { RootState } from "../types";
import Vue from "vue";

export const getters: GetterTree<NewslettersState, RootState> = {};
